import { render, staticRenderFns } from "./feature-grid.vue?vue&type=template&id=353d6c9a&scoped=true"
import script from "./feature-grid.vue?vue&type=script&lang=js"
export * from "./feature-grid.vue?vue&type=script&lang=js"
import style0 from "./feature-grid.vue?vue&type=style&index=0&id=353d6c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353d6c9a",
  null
  
)

export default component.exports